module.exports = __webpack_public_path__ + "img/CaseCreation.947844fd.png";